import React from 'react';
import MapDisplay from './MapDisplay';

import './index.scss';

export default function Overview() {
  return (
    <div className="model-performance-overview px-0 pt-2">
      <MapDisplay />
    </div>
  );
}
